/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import ButtonLink from '@/components/buttons/ButtonLink'
import MainTotalItems from '@/components/listings/MainTotalItems'
import DefaultCrudTable from '@/components/tables/DefaultCrudTable'
import RegularTemplate from '@/components/templates/RegularTemplate'
import { samsBuildBatchesUrls } from '@/configs/urls'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import React from 'react'
import CustomTableBody from './components/CustomTableBody'
import { columns } from './handlers'
import { getSamBuildBatches } from '@/services/sams-build-batches'
import { BUILD_SAM_BATCHES_TITLE, CREATE_BUILD_SAMS_BATCH_TITLE } from '@/configs/strings/sams-build-batches.strings'
import SimpleFilterBatchList from '@/components/listings/SimpleFilterBatchList'

const SamsBuildBatchesList = () => {
  const { base, create } = samsBuildBatchesUrls
  const urlCreate = `/${base}/${create}`
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    searchParams,
    setSearchParams,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getSamBuildBatches
  })

  const CreateButton = () => (
    <div className="my-5">
      <ButtonLink
        to={urlCreate}
        >
        { CREATE_BUILD_SAMS_BATCH_TITLE }
      </ButtonLink>
    </div>
  )

  return (
    <RegularTemplate
      title={BUILD_SAM_BATCHES_TITLE}
      childrenHeader={CreateButton}
      loadingContent={loading && !itemsResponse}
    >
      <SimpleFilterBatchList
        className="mb-3"
        onFilterResults={(filter) => setSearchParams(filter)}
        onReset={() => setSearchParams({})}
        searchParams={searchParams}
      />
      <MainTotalItems
        label={BUILD_SAM_BATCHES_TITLE}
        total={itemsResponse?.total}
        className="mb-3"
      />
      <DefaultCrudTable
        page={page}
        loading={loading}
        totalPages={totalPages}
        onPageChange={(page) => onChangePage(page)}
      >
        <DefaultCrudTable.Header
          columns={columns}
          actionsTitle="Actions"
        />
        <CustomTableBody
          columns={columns}
          items={itemsResponse?.data}
        />
      </DefaultCrudTable>
    </RegularTemplate>
  )
}

export default SamsBuildBatchesList
